<template>
  <div class="page_content">
    <div class="page_left">
      <div class="page_title">页面预览</div>
      <div class="model_box">
        <div class="model_title">{{ formData.title }}</div>
        <img
          class="bg_img"
          src="https://yckj-common.oss-cn-beijing.aliyuncs.com/1611910419.png"
          alt=""
        />
        <!-- <div class="money_box">xxx</div> -->
      </div>
      <!-- <div v-if="fromPage == 'list'" style="margin-top:20px;text-align:center">
        <el-button @click="showQrcode()">下载二维码</el-button>
      </div> -->
    </div>
    <div class="page_right">
      <div class="page_title title_bd">页面设置</div>
      <div class="form_line">活动名称：{{ formData.name }}</div>
      <div class="form_line">
        活动时间：{{ formData.start_time + " ~ " + formData.end_time }}
      </div>
      <!-- <div class="form_line">邀请人限制：{{}}</div> -->
      <div class="form_line">
        被邀人限制：{{ formData.new_user == 1 ? "新会员" : "未消费会员" }}
      </div>
      <div class="form_line">邀请成功条件设置：{{ formData.showQuery }}</div>
      <div class="form_line">
        活动标题：{{ formData.title ? formData.title : "默认" }}
      </div>
      <div class="form_line">
        活动规则：
        <div class="form_rule" v-html="formData.rule"></div>
      </div>
      <div class="page_title title_bd" style="margin-top:30px">奖励设置</div>
      <div class="table_box">
        <el-table :data="tableData" size="small" border>
          <el-table-column label="奖励类型" prop="type"></el-table-column>
          <el-table-column label="奖励条件" prop="query"></el-table-column>
          <el-table-column label="奖品类型" prop="value"></el-table-column>
        </el-table>
      </div>
      <div v-if="fromPage == 'invite'">
        <el-button @click="lastStep()">上一步</el-button>
        <el-button type="primary" @click="submit()">确定</el-button>
      </div>
    </div>
    <el-dialog
      :visible.sync="showResult"
      title="创建成功"
      width="800px"
      @close="closeResult"
      :close-on-click-modal="false"
      :show-close="false"
    >
      <result-form :id="result_id"></result-form>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { addInvite } from "@/api/market.js";
import ResultForm from "./result.vue";
export default {
  components: {
    ResultForm,
  },
  props: {
    step: {
      type: Number,
      default: 0,
    },
    fromPage: {
      type: String,
      default: "invite",
    },
  },
  watch: {
    step(val) {
      console.log("step: ", val);
      if (val == 3) {
        this.formData = Object.assign({}, this.inviteForm);
        this.formData.start_time =
          typeof this.formData.start_time == "number"
            ? this.mydateFormat(this.formData.start_time)
            : this.formData.start_time;
        this.formData.end_time =
          typeof this.formData.end_time == "number"
            ? this.mydateFormat(this.formData.end_time)
            : this.formData.end_time;
        this.formData.showQuery =
          this.formData.new_register == 1 ? "注册会员 " : "";
        if (this.formData.first_custom == 1) {
          this.formData.showQuery +=
            "完成消费(" +
            (this.formData.custom.goods_name
              ? this.formData.custom.goods_name
              : "") +
            (this.formData.custom.original == "1" ? "原价满" : "实付满") +
            this.formData.custom.money +
            "元)";
        }
        this.result_id = this.formData.id || "";
        console.log(this.formData);
        this.tableData = [];
        var tableItem = {
          type: "邀请成功奖励",
          query: "被邀请人",
          value:
            (this.formData.reward.point
              ? this.formData.reward.point + "积分 "
              : "") +
            (this.formData.reward.balance
              ? this.formData.reward.balance + "元余额 "
              : "") +
            (this.formData.reward.coupon
              ? this.formData.reward.coupon.split(",").length + "张优惠券"
              : ""),
        };
        tableItem.query += this.formData.new_register == 1 ? "注册会员 " : "";
        tableItem.query += this.formData.first_custom == 1 ? "完成消费" : "";
        this.tableData.push(Object.assign({}, tableItem));
        this.formData.step_reward.forEach((item) => {
          var stepItem = {
            type: "邀请成功阶梯奖励",
            query: "邀请成功" + item.invite_num + "人",
            value:
              (item.invite_reward.point
                ? item.invite_reward.point + "积分 "
                : "") +
              (item.invite_reward.balance
                ? item.invite_reward.balance + "元余额 "
                : "") +
              (item.invite_reward.coupon
                ? item.invite_reward.coupon.split(",").length + "张优惠券"
                : ""),
          };
          this.tableData.push(stepItem);
        });
        tableItem = {
          type: "接受邀请奖励",
          query: "被邀请人接受邀请",
          value:
            (this.formData.register_reward.point
              ? this.formData.register_reward.point + "积分 "
              : "") +
            (this.formData.register_reward.balance
              ? this.formData.register_reward.balance + "元余额 "
              : "") +
            (this.formData.register_reward.coupon
              ? this.formData.register_reward.coupon.split(",").length +
                "张优惠券"
              : ""),
        };
        this.tableData.push(Object.assign({}, tableItem));
      }
    },
  },
  computed: {
    ...mapGetters(["token", "app_id", "inviteForm"]),
  },
  data() {
    return {
      formData: {
        title: "标题",
      },
      tableData: [
        { type: "邀请成功奖励", query: "被邀人已消费", value: "3积分" },
        { type: "接受邀请奖励", query: "被邀人接受邀请", value: "300积分" },
      ],
      showResult: false,
      result_id: "0",
    };
  },
  methods: {
    nextStep() {
      this.$emit("nextStep");
    },
    lastStep() {
      this.$emit("lastStep");
    },
    submit() {
      var data = this.inviteForm;
      data.app_id = this.app_id;
      console.log(data);
      addInvite(data).then((res) => {
        if (res.code == 200) {
          this.$message.success("创建成功");
          this.showResult = true;
          this.result_id = res.data.id;
          // this.$router.go(-1)
        } else {
          this.$message(res.msg);
        }
      });
    },
    closeResult() {
      this.showResult = false;
    },
    showQrcode() {
      var linkUrl =
        localStorage.getItem("baseStatus") == "test"
          ? "https://cs.58zltc.com/"
          : "https://www.58zltc.com/";
      linkUrl +=
        "manage/activity.invite/downLoadInvite" +
        "?token=" +
        this.token +
        "&app_id=" +
        this.app_id +
        "&id=" +
        this.result_id;
      window.location.href = linkUrl;
    },
  },
};
</script>
<style lang="scss" scoped>
.page_content {
  display: flex;
  .page_left {
    width: 322px;
    margin: 0 40px;
    .model_box {
      width: 320px;
      height: 571px;
      background: #fafafa;
      position: relative;
      .model_title {
        height: 36px;
        padding-left: 5px;
        line-height: 36px;
        font-size: 16px;
        text-align: center;
        border: 1px solid #eee;
      }
      .bg_img {
        width: 320px;
        height: 535px;
      }
      .money_box {
        position: absolute;
        top: 274px;
        left: 118px;
        right: 98px;
        height: 56px;
        line-height: 56px;
        // border: 1px solid #fff;
        // background: #FFEEC4;
        font-size: 54px;
        font-weight: 700;
        background: linear-gradient(183deg, #ffe0ba 0%, #ffe5be 100%);
        color: #d91104;
      }
    }
  }
  .page_right {
    flex: 1;
    margin-right: 50px;
    .form_line {
      line-height: 34px;
      font-size: 14px;
      .form_rule {
        margin-left: 12px;
        display: inline-block;
      }
    }
    .table_box {
      margin-bottom: 30px;
    }
  }
  .page_title {
    padding-bottom: 16px;
    font-size: 16px;
  }
  .title_bd {
    border-bottom: 1px solid #eee;
    margin-bottom: 20px;
  }
}
</style>
